import { render, staticRenderFns } from "./swiper-pagination-primary.vue?vue&type=template&id=5b5ec8aa&scoped=true&"
import script from "./swiper-pagination-primary.vue?vue&type=script&lang=js&"
export * from "./swiper-pagination-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ec8aa",
  null
  
)

export default component.exports